export const BANK_ACCOUNT_PREFIX = 'ES '
export const BACKSPACE = 'Backspace'
